import { FC } from "react";

import { Stack } from "@mui/material";
import { UseFormReturn } from "react-hook-form";

import { isNameValid, isRequired } from "../../../../../helpers/validators";
import { useTranslate } from "../../../../../hooks/useTranslate";
import { UserData } from "../types";

import { DashboardEmailTextField } from "@/dashboard-design-system/EmailTextField";
import { DashboardTextField } from "@/dashboard-design-system/TextField";

export type UserInputsFormProps = {
  form: UseFormReturn<UserData>;
  disabled?: boolean;
  isOnlyEmail?: boolean;
};

export const UserInputsForm: FC<UserInputsFormProps> = ({ form, disabled, isOnlyEmail }) => {
  const { t } = useTranslate();
  const { errors } = form.formState;

  return (
    <Stack direction="column" spacing={1}>
      {!isOnlyEmail && (
        <Stack direction="row" spacing={1}>
          <DashboardTextField
            control={form.control}
            size="medium"
            name="firstName"
            data-test="first-name"
            label={t("dashboard", "usersManagement.firstName")}
            errorMessage={errors["firstName"]?.message}
            rules={[
              isRequired(t("dashboard", "usersManagement.firstNameIsRequired")),
              isNameValid(t("common", "invalidCharacterUsed")),
            ]}
            disabled={disabled}
          />

          <DashboardTextField
            control={form.control}
            size="medium"
            name="lastName"
            data-test="last-name"
            label={t("dashboard", "usersManagement.lastName")}
            errorMessage={errors["lastName"]?.message}
            rules={[
              isRequired(t("dashboard", "usersManagement.lastNameIsRequired")),
              isNameValid(t("common", "invalidCharacterUsed")),
            ]}
            disabled={disabled}
          />
        </Stack>
      )}

      <DashboardEmailTextField
        control={form.control}
        size="medium"
        name="email"
        data-test="email"
        label={t("dashboard", "usersManagement.email")}
        errorMessage={errors["email"]?.message}
        rules={[
          {
            required: {
              value: true,
              message: t("dashboard", "usersManagement.emailIsRequired") as string,
            },
          },
        ]}
        disabled={disabled}
      />
    </Stack>
  );
};
